import { SendInvitationResult } from '../../../application/domain/entities/SendInvitationResult';
import { SendInvitationResponseDto } from '../dto/res/SendInvitationResponseDto';

export function mapSendInvitationResponseToEntity(dto: SendInvitationResponseDto): SendInvitationResult {
    return {
        i9FormId: dto.i9FormId,
        email: dto.email,
        emailSent: dto.emailSent,
    };
}
